import { FETCH_ACADEMIC_SUCCESS } from 'constants/academic';

import type { Field } from 'models/field';
import { combineReducers } from 'redux';

type AcademicAction = {
  type: typeof FETCH_ACADEMIC_SUCCESS;
  payload: {
    entities: {
      fields: Record<string, Field>;
    };
    result: string[];
  };
};

export const byId = (
  state: Record<string, Field> = {},
  action: AcademicAction,
) => {
  switch (action.type) {
    case FETCH_ACADEMIC_SUCCESS:
      const {
        entities: { fields = {} },
      } = action.payload;
      return fields;
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: AcademicAction) => {
  switch (action.type) {
    case FETCH_ACADEMIC_SUCCESS:
      const { result: fieldIds } = action.payload;
      return fieldIds;
    default:
      return state;
  }
};

const academic = combineReducers({ byId, ids });

export { academic };
